import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { TiInfoOutline } from "react-icons/ti";
import { axios } from "../../../../Global";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import { useNavigate } from "react-router-dom";
import { CgSpinner } from "react-icons/cg";

export default function QuotationToContract({ showPopup, setShowPopup }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const state = showPopup?.state || {};

  const [loading, setLoading] = useState(false);

  const proceedContractHandler = () => {
    setLoading(true);
    axios
      .post(
        `/dashboard/quotation-to-contract-conversion/${state?.quotationId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        console.log(response);
        if (response.status == 200) {
          navigate(`/dashboard/contract/${response?.data?.data?.id}`);
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          setAppError({
            msg: error?.response?.data?.message || "Something went wrong!",
          })
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        showPopup.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-md w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative items-center">
        <div className="flex justify-between items-center w-full">
          <h1 className="text-lg font-semibold">Create Contract</h1>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setShowPopup(() => ({ open: false }));
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <h2 className="text-sm self-start">
          Create a new contract for your quotation.
        </h2>
        <div className="w-full self-start mt-5 flex flex-col gap-1 font-medium">
          <h2 className="text-sm ">Quotation No. - {state?.quotationNumber}</h2>
          <h2 className="text-sm ">Quotation Name - {state?.quotationName}</h2>
        </div>

        <div className="w-full flex justify-center gap-3 min-w-fit mt-10">
          <button
            className="w-full p-2 rounded-md ring-1 ring-slate-600"
            onClick={() => {
              setShowPopup(() => ({ open: false }));
            }}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="w-full p-2 rounded-md ring-1 ring-red text-white bg-red flex justify-center items-center"
            onClick={() => {
              proceedContractHandler();
            }}
            disabled={loading}
          >
            {loading ? (
              <CgSpinner className="animate-spin" size={"1.2rem"} />
            ) : (
              "Proceed"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
